import React, { useState, useEffect } from 'react';
import type { MenuProps } from 'antd';
import { Dropdown } from 'antd';
import styled from 'styled-components';
import { AiOutlineGlobal } from 'react-icons/ai';
import { useTranslation } from 'react-i18next';
import { localStorageServices } from 'services/localStorageServices';
import { theme } from 'utils/style/theme';
import { queryAppLang } from 'apis/common/commonApis';
import ViewerDownLoadButton from './ViewerDownLoadButton';

const LangsBtn = styled.div`
  border-top: 1px solid #6c8fe0;
  padding: 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: absolute;
  width: 100%;
  bottom: -5rem;
  left: 0;
  background-color: ${theme.colors.blue_500};
`;
const SelectDiv = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.5rem;
  & > * + * {
    margin-left: 0.5rem;
  }
`;

const LngText = styled.p`
  color: #ffffff;
`;

const SidebarBottom: React.FC = () => {
  const { i18n } = useTranslation();
  const [selectedLng, setSelectLng] = useState('한국어');
  const { data: appLangList } = queryAppLang(); // 제작시스템의 언어

  const handleSetLang = (value: string) => {
    localStorageServices.setI18Lng(value);
    i18n.changeLanguage(value);
    if (value === 'ko') {
      setSelectLng('한국어');
    }
    if (value === 'en') {
      setSelectLng('English');
    }
    if (value === 'jp') {
      setSelectLng('日本語');
    }
  };

  useEffect(() => {
    const lng = localStorageServices.getI18Lng();
    if (lng === 'ko') {
      setSelectLng('한국어');
    }
    if (lng === 'en') {
      setSelectLng('English');
    }
    if (lng === 'jp') {
      setSelectLng('日本語');
    }
  }, []);

  const items: MenuProps['items'] = [
    {
      key: 'ko',
      label: <p onClick={() => handleSetLang('ko')}>한국어</p>,
    },
    {
      key: 'en',
      label: <p onClick={() => handleSetLang('en')}>English</p>,
    },
    {
      key: 'jp',
      label: <p onClick={() => handleSetLang('jp')}>日本語</p>,
    },
  ];
  return (
    <LangsBtn>
      <ViewerDownLoadButton />
      <Dropdown menu={{ items }} placement='top'>
        <SelectDiv>
          <AiOutlineGlobal style={{ color: 'white' }} />
          <LngText>{selectedLng}</LngText>
        </SelectDiv>
      </Dropdown>
    </LangsBtn>
  );
};

export default SidebarBottom;
